import { render, staticRenderFns } from "./m-practice-lead-item.vue?vue&type=template&id=6485f210"
import script from "./m-practice-lead-item.vue?vue&type=script&lang=js"
export * from "./m-practice-lead-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports